import { useContext } from 'react';

import { AuthContext } from './types';

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthContext provider');
  }
  return context;
};
